/* src/app/shared/protocolo-ipd/importacao-lote-ipd/importacao-lote-ipd.component.scss */
.custom-file-input ~ .custom-file-label::after {
  content: "Selecionar";
}
.erros-upload {
  margin-top: 50px !important;
}
table {
  width: 90%;
}
textarea {
  font-size: 12px;
}
.obs-erro {
  margin-top: 5px !important;
  font-style: italic;
  font-size: 12px;
}
.arquivo-selecionado {
  font-size: 0.7rem;
  margin-top: 12px;
  color: blue;
}
/*# sourceMappingURL=importacao-lote-ipd.component.css.map */
